import { rotuloDaFilial } from '../../componentes/deposito.js';
import './CaminhoDeDepositos.css';

type Props = {
  readonly depositoOrigem: string | null;
  readonly filialOrigem: number | null;
  readonly depositoDestino: string;
  readonly filialDestino: number | null;
};

/**
 * Origem → destino, o dado que responde "para onde foi a caixa".
 *
 * Os depósitos em fonte monoespaçada (RF-041): código se lê caractere a
 * caractere, e `ALM01` precisa se distinguir de `ALMO1` na varredura vertical.
 * A filial vai na linha de baixo — origem e destino são sempre da mesma
 * (`MOVIMENTACAO_ENTRE_FILIAIS`), então repeti-la dos dois lados seria ruído.
 *
 * Sem origem conhecida, a célula **diz** que não sabe (UC08 4a) em vez de
 * mostrar um travessão que passaria por depósito curto.
 */
export function CaminhoDeDepositos({
  depositoOrigem,
  filialOrigem,
  depositoDestino,
  filialDestino,
}: Props) {
  const filial = filialDestino ?? filialOrigem;

  return (
    <span className="caminho-depositos">
      {depositoOrigem === null && (
        <span className="caminho-depositos__sem-origem">origem não informada</span>
      )}
      <span className="caminho-depositos__locais">
        {depositoOrigem === null
          ? `→ ${depositoDestino}`
          : `${depositoOrigem} → ${depositoDestino}`}
      </span>
      {filial !== null && (
        <span className="caminho-depositos__nomes">{rotuloDaFilial(filial)}</span>
      )}
    </span>
  );
}
